import { IAdminLogin } from '../../../../constants/interfaces';
import { validateEmail } from '../../../../utils/validation/validation';

export const validateDataToSend = (
  dataToSend: IAdminLogin,
  setError: (v: string) => void
) => {
  const { email, password } = dataToSend;

  if (!email) {
    setError('Please enter your email.');
    return false;
  }

  if (email.length > 50) {
    setError('Email can not be more than 50 characters');
    return false;
  }

  if (!validateEmail(email)) {
    setError('Please enter e valid email address');
    return false;
  }

  if (!password) {
    setError('Please enter your password.');
    return false;
  }

  // validate password
  if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(password)) {
    setError(
      'Password should have minimum eight characters, at least one letter and one number'
    );
    return false;
  }

  return true;
};
